import { AlertTriangle } from "lucide-react";
import { money } from "../lib/api";

export const BudgetAlerts = ({ categories }) => {
  const alerts = categories.filter(c => c.budget > 0 && c.percent >= 80).sort((a, b) => b.percent - a.percent);
  if (!alerts.length) return null;
  return <section className="budget-alerts" data-testid="budget-alerts">
    <div className="budget-alerts-head"><AlertTriangle size={18} /><div><strong>Peringatan anggaran</strong><span>{alerts.length} kategori sudah memakai 80% atau lebih anggaran bulan ini</span></div><a className="text-link" href="/budgets">Kelola anggaran →</a></div>
    <div className="budget-alerts-list">{alerts.map(c => <div className={`alert-chip ${c.percent >= 100 ? "over" : "warn"}`} key={c.id} data-testid={`budget-alert-${c.id}`}>
      <strong>{c.name}</strong><span>{c.percent}% · {c.remaining < 0 ? `lewat ${money(-c.remaining)}` : `sisa ${money(c.remaining)}`}</span>
    </div>)}</div>
  </section>;
};
